export const getEnvVarAsBoolean = (value) => {
	if (!value) {
		return false
	}
	if (value === 'false' || value === 'disabled') {
		return false
	}
	return true
}
